import { cn, signed } from "./api";
import "./rivals.css";

type Comparison = {
  count: number;
  myProfit: number | null;
  rows: {
    id: string;
    name: string;
    rule: string;
    profit: number | null;
    difference: number | null;
  }[];
};
export function RivalComparison({
  data,
  start,
  monthly = false,
}: {
  data: Comparison;
  start?: () => void;
  monthly?: boolean;
}) {
  return (
    <section className="panel rival-panel" aria-label="공식 라이벌 비교">
      <div className="section-heading">
        <div>
          <span className="rival-eyebrow">공식 라이벌 · 시뮬레이션</span>
          <h2>
            {data.count ? "같은 문제, 다른 선택" : "나의 첫 상대를 만나보세요"}
          </h2>
        </div>
      </div>
      <p className="rival-description">
        {data.count
          ? `${monthly ? "선택한 달에 " : ""}직접 끝까지 푼 데일리 ${data.count}판을 같은 조건으로 비교해요.`
          : "데일리 한 판을 직접 끝까지 풀면 다섯 라이벌과 성적을 비교할 수 있어요."}
      </p>
      {data.myProfit !== null && (
        <div className="rival-my-profit">
          <span>
            {monthly ? "비교 대상 판의 내 누적 손익" : "이번 판의 내 손익"}
          </span>
          <strong className={cn(data.myProfit)}>{signed(data.myProfit)}</strong>
        </div>
      )}
      <ul className="rival-list">
        {data.rows.map((rival) => (
          <li key={rival.id}>
            <span className={`rival-mark rival-${rival.id}`} aria-hidden="true">
              {
                { hold: "유지", half: "½", buy: "+", sell: "₩", random: "?" }[
                  rival.id
                ]
              }
            </span>
            <div className="rival-identity">
              <strong>{rival.name}</strong>
              <small>{rival.rule}</small>
            </div>
            {rival.profit !== null && rival.difference !== null && (
              <div className="rival-score">
                <strong className={cn(rival.profit)}>
                  {signed(rival.profit)}
                </strong>
                <small>
                  {rival.difference === 0
                    ? "나와 같은 손익"
                    : `내가 ${signed(Math.abs(rival.difference)).replace(/^\+/, "")} ${rival.difference > 0 ? "앞서요" : "뒤처져요"}`}
                </small>
              </div>
            )}
          </li>
        ))}
      </ul>
      {!data.count && start && (
        <button className="btn primary" onClick={start}>
          오늘의 도전 시작
        </button>
      )}
      <p className="rival-note">
        정해진 규칙으로 계산한 가상 상대예요. 실제 이용자 순위와 시즌 보상에는
        포함되지 않아요.
      </p>
    </section>
  );
}
